import React from 'react'
import ReactDOM from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import App from '@/App.jsx'
import '@/index.css'
import { bootstrapNative } from '@/native/bootstrap'

// Inside the iOS app: route API calls to defera.app, open outside links in
// Safari, style the status bar. A no-op in the browser.
bootstrapNative()

ReactDOM.createRoot(document.getElementById('root')).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
) 